import {
  personalVehicleInfo,
  velotrackVehicleInfo,
} from "../../../../common/helpers/vehicle-edit-constants";
import { GenericInfoField } from "../../../../common/components/ui/GenericInfoField";
import { useVehicleDashboardContext } from "./useVehicleDashboardContext";
import { brDateFormat } from "../../../../common/helpers/date.helpers";

function VehicleInfo() {
  const { vehicle } = useVehicleDashboardContext();
  const setpersonalVehicleInfo = personalVehicleInfo(vehicle);
  const setVelotrackVehicleInfo = velotrackVehicleInfo(vehicle);

  const partnerInfo = vehicle?.partnerInfo;
  const trafficFines = partnerInfo?.managementTrafficfines;
  const isLocavibe = partnerInfo?.companyName?.toUpperCase().includes("LOCAVIBE");

  return (
    <>
      <h2 className="text-2xl font-semibold mb-4">Informações do veículo</h2>
      <section className="col-span-full bg-gray/20 dark:text-black p-4 rounded-md">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 grid-rows-3 gap-2">
          {setpersonalVehicleInfo.map((info) => {
            return (
              <GenericInfoField
                id={info.id}
                spanSize={info.spanSize}
                label={info.label}
                value={info.value}
              />
            );
          })}
        </div>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Proprietário do Veículo</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
          <GenericInfoField
            id="owner-name"
            spanSize="col-span-1 md:col-span-2"
            label="Nome"
            value={partnerInfo?.companyName}
          />
          <GenericInfoField
            id="owner-cnpj"
            spanSize="col-span-1"
            label="CNPJ"
            value={partnerInfo?.partnerCnpj ?? partnerInfo?.cnpj}
          />
          {!isLocavibe && (
            <>
              <GenericInfoField
                id="owner-traffic-fines"
                spanSize="col-span-1"
                label="Gestão de multas"
                value={trafficFines ? (trafficFines.enabled ? "Sim" : "Não") : "-"}
              />
              {trafficFines?.enabled && (
                <GenericInfoField
                  id="owner-traffic-fines-date"
                  spanSize="col-span-1"
                  label="Gestão de multas desde"
                  value={trafficFines.date ? brDateFormat(trafficFines.date) : "-"}
                />
              )}
            </>
          )}
        </div>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Integrações</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
          {setVelotrackVehicleInfo.map((info) => (
            <GenericInfoField
              id={info.id}
              spanSize="col-span-1"
              label={info.label}
              value={info.value}
            />
          ))}
        </div>
      </section>
    </>
  );
}
export default VehicleInfo;
